// extracted by mini-css-extract-plugin
export var fadeInOut = "_2h-3";
export var icon = "_2h-4";
export var savedIndicator = "_2h-2";
export var savingIndicator = "_2h-0";
export var spin = "_2h-1";